import { registerDynamicListToolbarExtension } from "@/utils/dynamicListToolbarRegistry";

registerDynamicListToolbarExtension({
  requiresModule: "duntower_module",
  component: () =>
    import("@/components/gotrading/shipping/ShippingExpensesCopyToShippingToolbar.vue"),
});
